export default class ApiDatabase {
    constructor() {
        const isLocal = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
        this.baseUrl = isLocal ? 'http://localhost:3000' : 'https://pixelblob.fr/api';
        const legacyToken = localStorage.getItem('quicky_session_token');
        this.token = localStorage.getItem('pixelblob_session_token') || legacyToken;
        if (!localStorage.getItem('pixelblob_session_token') && legacyToken) {
            localStorage.setItem('pixelblob_session_token', legacyToken);
        }

        // Hardcoded Catalog for Client Lookup
        this.catalog = [
            { id: 'neon-core', type: 'theme', price: 0, name: 'Neon Core' },
            { id: 'cyber-green', type: 'theme', price: 300, name: 'Cyber Green' },
            { id: 'solar-flare', type: 'theme', price: 300, name: 'Solar Flare' },
            { id: 'midnight', type: 'theme', price: 200, name: 'Midnight' },
            { id: 'crimson-tide', type: 'theme', price: 300, name: 'Crimson Tide' },
            { id: 'ocean-breeze', type: 'theme', price: 300, name: 'Ocean Breeze' },
            { id: 'candy-pop', type: 'theme', price: 400, name: 'Candy Pop' },
            { id: 'toxic-waste', type: 'theme', price: 400, name: 'Toxic Waste' },
            { id: 'sunset-blvd', type: 'theme', price: 400, name: 'Sunset Blvd' },
            { id: 'deep-space', type: 'theme', price: 500, name: 'Deep Space' },
            { id: 'forest-fire', type: 'theme', price: 500, name: 'Forest Fire' },
            { id: 'royal-guard', type: 'theme', price: 600, name: 'Royal Guard' },
            { id: 'ice-cold', type: 'theme', price: 300, name: 'Ice Cold' },
            { id: 'lava-flow', type: 'theme', price: 500, name: 'Lava Flow' },
            { id: 'bubblegum', type: 'theme', price: 300, name: 'Bubblegum' },
            { id: 'mint-choc', type: 'theme', price: 300, name: 'Mint Choc' },
            { id: 'bumblebee', type: 'theme', price: 400, name: 'Bumblebee' },
            { id: 'vaporwave', type: 'theme', price: 500, name: 'Vaporwave' },
            { id: 'matrix', type: 'theme', price: 1200, name: 'The Matrix' },
            { id: 'rainbow', type: 'theme', price: 2500, name: 'Rainbow' },
            { id: 'dracula', type: 'theme', price: 600, name: 'Dracula' },
            { id: 'pumpkin', type: 'theme', price: 300, name: 'Pumpkin' },
            { id: 'aquamarine', type: 'theme', price: 400, name: 'Aquamarine' },
            { id: 'berry-blast', type: 'theme', price: 400, name: 'Berry Blast' },
            { id: 'neon-gold', type: 'theme', price: 500, name: 'Neon Gold' },
            { id: 'neon-ice', type: 'theme', price: 300, name: 'Neon Ice' },
            { id: 'neon-cyber', type: 'theme', price: 800, name: 'Neon Cyber' },
            { id: 'neon-nature', type: 'theme', price: 300, name: 'Neon Nature' },
            { id: 'neon-sunset', type: 'theme', price: 400, name: 'Neon Sunset' },

            // Effects
            { id: 'effect-neon', type: 'effect', price: 50, name: 'Neon' },
            { id: 'effect-metal', type: 'effect', price: 200, name: 'Metal' },
            { id: 'effect-fire', type: 'effect', price: 1000, name: 'Fire' },
            { id: 'effect-water', type: 'effect', price: 400, name: 'Water' },
            { id: 'effect-cyberpunk', type: 'effect', price: 1500, name: 'Cyberpunk' },
            { id: 'effect-galaxy', type: 'effect', price: 2000, name: 'Galaxy' },
            { id: 'effect-matrix', type: 'effect', price: 1200, name: 'Matrix' },
            { id: 'effect-ice', type: 'effect', price: 500, name: 'Ice' },
            { id: 'effect-electric', type: 'effect', price: 800, name: 'Electric' },
            { id: 'effect-rainbow', type: 'effect', price: 2500, name: 'Rainbow' },
            { id: 'effect-hologram', type: 'effect', price: 1200, name: 'Hologram' },
            { id: 'effect-gold', type: 'effect', price: 5000, name: 'Gold' },
            { id: 'effect-toxic', type: 'effect', price: 600, name: 'Toxic' },
            { id: 'effect-arcade', type: 'effect', price: 1000, name: 'Arcade' },
            { id: 'effect-crystal', type: 'effect', price: 2200, name: 'Crystal' },
            { id: 'effect-circuit', type: 'effect', price: 1400, name: 'Circuit' },
            { id: 'effect-hazard', type: 'effect', price: 600, name: 'Hazard' },
            { id: 'effect-phantom', type: 'effect', price: 1800, name: 'Phantom' },
            { id: 'effect-soap', type: 'effect', price: 400, name: 'Soap' },
            { id: 'effect-sketch', type: 'effect', price: 900, name: 'Sketch' },
            { id: 'effect-grid', type: 'effect', price: 700, name: 'Grid' },
            { id: 'effect-magma', type: 'effect', price: 1600, name: 'Magma' },
            { id: 'effect-scanner', type: 'effect', price: 1100, name: 'Scanner' },
            { id: 'effect-static', type: 'effect', price: 300, name: 'Static' }
        ];
    }

    async loadCatalog() {
        try {
            const res = await fetch(`${this.baseUrl}/economy/shop-items`);
            if (res.ok) {
                const items = await res.json();
                this.catalog = items.map(i => ({
                    id: i.id,
                    type: i.type.toLowerCase(),
                    price: i.price,
                    name: i.name
                }));
            }
        } catch (e) {
            console.error("Failed to load catalog from server:", e);
        }
    }

    getPrice(itemId) {
        const item = this.catalog.find(i => i.id === itemId);
        return item ? item.price : 999999;
    }

    async _fetch(endpoint, method = 'GET', body = null) {
        const headers = { 'Content-Type': 'application/json' };
        if (this.token) {
            headers['Authorization'] = `Bearer ${this.token}`;
        }

        const config = {
            method,
            headers,
        };

        if (body) {
            config.body = JSON.stringify(body);
        }

        try {
            // CACHE BUSTING
            let url = `${this.baseUrl}${endpoint}`;
            if (method === 'GET') {
                const separator = url.includes('?') ? '&' : '?';
                url += `${separator}_t=${Date.now()}`;
            }

            console.log(`[API] Fetching ${url}`);
            const res = await fetch(url, config);

            let data;
            const contentType = res.headers.get("content-type");
            if (contentType && contentType.includes("application/json")) {
                data = await res.json();
            } else {
                // If not JSON (likely 502/500 HTML), treat as error text
                const text = await res.text();
                throw new Error(`Server returned non-JSON response (${res.status}): ${text.substring(0, 100)}...`);
            }

            if (!res.ok) {
                throw new Error(data.message || 'API Error');
            }
            return data;
        } catch (err) {
            console.error("API Request Failed:", err);
            throw err;
        }
    }

    // --- AUTH ---

    async authenticatedFetch(endpoint, options = {}) {
        const url = `${this.baseUrl}${endpoint}`;
        const headers = {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${this.token}`,
            ...options.headers
        };
        return fetch(url, { ...options, headers });
    }

    async loginUser(email, password) {
        const data = await this._fetch('/auth/login', 'POST', { email, password });
        this.token = data.token;
        localStorage.setItem('pixelblob_session_token', data.token);
        localStorage.setItem('quicky_session_token', data.token);
        return data.user;
    }

    async createUser(username, email, password) {
        const data = await this._fetch('/auth/register', 'POST', { username, email, password });
        this.token = data.token;
        localStorage.setItem('pixelblob_session_token', data.token);
        localStorage.setItem('quicky_session_token', data.token);
        return data.user;
    }

    async convertGuest(username, email, password) {
        return await this._fetch('/auth/convert', 'POST', { username, email, password });
    }

    async resendVerification() {
        return await this._fetch('/auth/resend-verification', 'POST');
    }

    async requestPasswordReset(email) {
        return await this._fetch('/auth/forgot-password', 'POST', { email });
    }

    async resetPassword(token, password) {
        return await this._fetch('/auth/reset-password', 'POST', { token, password });
    }

    async registerGuest(deviceId, fingerprint) {
        const data = await this._fetch('/auth/guest', 'POST', { deviceId, fingerprint });
        this.token = data.token;
        localStorage.setItem('pixelblob_session_token', data.token);
        localStorage.setItem('quicky_session_token', data.token);
        return data.user;
    }

    logout() {
        this.token = null;
        localStorage.removeItem('pixelblob_session_token');
        localStorage.removeItem('quicky_session_token');
    }

    // --- USER DATA ---

    async getUser(userId) {
        return await this._fetch('/user/me');
    }

    async addFriend(friendCode) {
        try {
            const data = await this._fetch('/user/add-friend', 'POST', { friendCode });
            return { success: true, message: "Friend added" };
        } catch (e) {
            return { success: false, message: e.message || "Failed to add friend" };
        }
    }

    async getFriends() {
        try {
            const data = await this._fetch('/user/friends');
            return data || [];
        } catch (e) {
            console.warn("Fetch friends failed", e);
            return [];
        }
    }

    async getUserBestScores() {
        try {
            return await this._fetch('/user/pbs');
        } catch (e) {
            console.warn("Fetch PBs failed", e);
            return { _error: e.toString() };
        }
    }

    // --- ECONOMY ---

    async purchaseItem(itemId, price, type) {
        return await this._fetch('/user/buy', 'POST', { itemId, price, type });
    }

    async updateUserPreferences(userId, themeId, effectId) {
        return await this._fetch('/user/preferences', 'POST', { themeId, effectId });
    }

    async updatePromotionLink(link) {
        return await this._fetch('/user/promotion-link', 'POST', { link });
    }

    // --- TEMPLATE COMPAT (gameplay disabled) ---
    async submitGameResult() { return { success: false, message: 'Gameplay disabled in this template' }; }
    async updateScoreTag() { return { success: false, message: 'Gameplay disabled in this template' }; }
    async getUserRanks() { return null; }
    async getLeaderboard() { return []; }

    // --- COMPATIBILITY STUBS ---
    unlockGameForUser() { return { success: true }; }
    updatePersonalBest() { return true; }
    getUserInventory() { return []; }
}
